/* ═══════════════════════════════════════════════════════════════
   Smith's Blades — Product Page
   Step 7: Lightbox + all interactions
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ═══════════════════════════════════════
     SHARED IMAGE DATA
     Build array once — used by gallery + lightbox
     ═══════════════════════════════════════ */
  let imageData = [];
  let currentIndex = 0;

  function buildImageData() {
    const thumbs = $$('[data-thumb]');
    imageData = thumbs.map(t => ({
      src:     t.dataset.fullSrc  || '',
      srcset:  t.dataset.srcset   || '',
      zoomSrc: t.dataset.zoomSrc  || t.dataset.fullSrc || '',
      alt:     t.dataset.alt      || ''
    }));
  }

  /* ═══════════════════════════════════════
     GALLERY — THUMBNAIL SWAP + ARROWS
     ═══════════════════════════════════════ */
  function initGallery() {
    const mainImg        = $('#sp-main-img');
    const thumbsContainer = $('#sp-gallery-thumbs');
    const prevBtn        = $('[data-gallery-prev]');
    const nextBtn        = $('[data-gallery-next]');
    const counterCurrent = $('.sp-gallery__counter [data-current]');

    if (!mainImg || !thumbsContainer) return;

    const thumbs     = $$('[data-thumb]', thumbsContainer);
    const totalImages = thumbs.length;

    /* Set active thumb + counter */
    function setActive(index) {
      currentIndex = index;
      thumbs.forEach((t, i) => {
        const active = i === index;
        t.classList.toggle('sp-gallery__thumb--active', active);
        t.setAttribute('aria-pressed', String(active));
      });
      if (counterCurrent) counterCurrent.textContent = index + 1;
      mainImg.dataset.currentIndex = index;
    }

    /* Change to image by index */
    function changeImage(index) {
      if (index < 0 || index >= totalImages) return;
      const data = imageData[index];
      if (!data) return;
      mainImg.src    = data.src;
      mainImg.srcset = data.srcset;
      mainImg.alt    = data.alt;
      mainImg.dataset.zoomSrc = data.zoomSrc;
      setActive(index);
    }

    /* Thumbnail click */
    thumbsContainer.addEventListener('click', function (e) {
      const thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      changeImage(parseInt(thumb.dataset.index, 10));
    });

    /* Previous arrow */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        changeImage((currentIndex - 1 + totalImages) % totalImages);
      });
    }

    /* Next arrow */
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        changeImage((currentIndex + 1) % totalImages);
      });
    }

    /* Swipe — mobile */
    let touchStartX = 0;
    mainImg.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    mainImg.addEventListener('touchend', function (e) {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) < 50) return;
      if (diff > 0 && nextBtn) nextBtn.click();
      else if (diff < 0 && prevBtn) prevBtn.click();
    }, { passive: true });
  }

  /* ═══════════════════════════════════════
     LIGHTBOX
     ═══════════════════════════════════════ */
  function initLightbox() {
    const lightbox      = $('#sp-lightbox');
    const lightboxImg   = $('#sp-lightbox-img');
    const loader        = $('#sp-lightbox-loader');
    const closeBtns     = $$('[data-lightbox-close]');
    const lbPrev        = $('[data-lightbox-prev]');
    const lbNext        = $('[data-lightbox-next]');
    const lbCurrent     = $('#sp-lightbox-current');
    const mainImg       = $('#sp-main-img');
    const galleryMain   = $('#sp-gallery-main');
    const zoomBtn       = $('[data-zoom-btn]');

    if (!lightbox || !lightboxImg) return;

    /* Open lightbox */
    function openLightbox(index) {
      if (!imageData.length) return;

      const clampedIndex = Math.max(0, Math.min(index, imageData.length - 1));
      loadLightboxImage(clampedIndex);

      lightbox.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';

      /* Focus trap — focus close button */
      const closeBtn = lightbox.querySelector('[data-lightbox-close]');
      if (closeBtn) setTimeout(() => closeBtn.focus(), 50);
    }

    /* Close lightbox */
    function closeLightbox() {
      lightbox.setAttribute('hidden', '');
      document.body.style.overflow = '';

      /* Return focus to zoom button */
      if (zoomBtn) zoomBtn.focus();
    }

    /* Load image into lightbox */
    function loadLightboxImage(index) {
      const data = imageData[index];
      if (!data) return;

      currentIndex = index;

      /* Show loader */
      lightboxImg.classList.add('sp-lightbox__img--loading');
      if (loader) loader.removeAttribute('hidden');

      /* Update counter */
      if (lbCurrent) lbCurrent.textContent = index + 1;

      /* Load image */
      const tempImg = new Image();
      tempImg.onload = function () {
        lightboxImg.src = data.zoomSrc;
        lightboxImg.alt = data.alt;
        lightboxImg.classList.remove('sp-lightbox__img--loading');
        if (loader) loader.setAttribute('hidden', '');
      };
      tempImg.onerror = function () {
        /* Fallback to regular src */
        lightboxImg.src = data.src;
        lightboxImg.alt = data.alt;
        lightboxImg.classList.remove('sp-lightbox__img--loading');
        if (loader) loader.setAttribute('hidden', '');
      };
      tempImg.src = data.zoomSrc;
    }

    /* Navigate in lightbox */
    function lightboxPrev() {
      const prev = (currentIndex - 1 + imageData.length) % imageData.length;
      loadLightboxImage(prev);
      /* Also sync gallery */
      const galleryPrev = $('[data-gallery-prev]');
      if (galleryPrev) galleryPrev.click();
    }

    function lightboxNext() {
      const next = (currentIndex + 1) % imageData.length;
      loadLightboxImage(next);
      /* Also sync gallery */
      const galleryNext = $('[data-gallery-next]');
      if (galleryNext) galleryNext.click();
    }

    /* Zoom button click */
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        openLightbox(currentIndex);
      });
    }

    /* Main image click */
    if (galleryMain) {
      galleryMain.addEventListener('click', function (e) {
        /* Don't open if clicking arrows, wishlist or zoom btn */
        if (e.target.closest('[data-gallery-prev]')) return;
        if (e.target.closest('[data-gallery-next]')) return;
        if (e.target.closest('[data-wishlist-btn]')) return;
        if (e.target.closest('[data-zoom-btn]')) return;
        openLightbox(currentIndex);
      });
    }

    /* Close on backdrop / close button */
    closeBtns.forEach(btn => {
      btn.addEventListener('click', closeLightbox);
    });

    /* Lightbox navigation */
    if (lbPrev) lbPrev.addEventListener('click', lightboxPrev);
    if (lbNext) lbNext.addEventListener('click', lightboxNext);

    /* Keyboard navigation */
    document.addEventListener('keydown', function (e) {
      /* Only handle keys when lightbox is open */
      if (lightbox.hasAttribute('hidden')) {
        /* Gallery keyboard nav when lightbox closed */
        if (e.target.closest('.sp-gallery__main') || e.target.closest('.sp-gallery__thumbs')) {
          const galleryPrev = $('[data-gallery-prev]');
          const galleryNext = $('[data-gallery-next]');
          if (e.key === 'ArrowLeft' && galleryPrev) galleryPrev.click();
          if (e.key === 'ArrowRight' && galleryNext) galleryNext.click();
        }
        return;
      }

      switch (e.key) {
        case 'Escape':
          closeLightbox();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          lightboxPrev();
          break;
        case 'ArrowRight':
          e.preventDefault();
          lightboxNext();
          break;
      }
    });

    /* Swipe in lightbox */
    let lbTouchStartX = 0;
    lightbox.addEventListener('touchstart', function (e) {
      lbTouchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      const diff = lbTouchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) < 50) return;
      if (diff > 0) lightboxNext();
      else lightboxPrev();
    }, { passive: true });
  }

  /* ═══════════════════════════════════════
     WISHLIST
     ═══════════════════════════════════════ */
  function initWishlist() {
    const btn = $('[data-wishlist-btn]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const pressed = this.getAttribute('aria-pressed') === 'true';
      this.setAttribute('aria-pressed', String(!pressed));
    });
  }

  /* ═══════════════════════════════════════
     QUANTITY STEPPER
     ═══════════════════════════════════════ */
  function initQuantity() {
    const qtyInput   = $('[data-qty-input]');
    const subtotalEl = $('[data-qty-subtotal]');
    const qtyBtns    = $$('[data-qty-change]');
    if (!qtyInput || !subtotalEl) return;

    const priceEl        = $('[data-product-price]');
    const unitPriceCents = priceEl ? parseInt(priceEl.dataset.productPrice, 10) : 0;

    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function updateSubtotal() {
      if (!unitPriceCents) return;
      const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      subtotalEl.textContent = 'Subtotal: ' + formatMoney(unitPriceCents * qty);
    }

    qtyBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        const change  = parseInt(this.dataset.qtyChange, 10);
        const current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, Math.min(99, current + change));
        updateSubtotal();
      });
    });

    qtyInput.addEventListener('change', function () {
      const val = parseInt(this.value, 10);
      if (isNaN(val) || val < 1) this.value = 1;
      else if (val > 99) this.value = 99;
      updateSubtotal();
    });

    updateSubtotal();
  }

  /* ═══════════════════════════════════════
     TABS
     ═══════════════════════════════════════ */
  function initTabs() {
    const tabBtns = $$('.sp-tabs__btn');
    const panels  = $$('.sp-tabs__panel');
    if (!tabBtns.length) return;

    function activateTab(btn) {
      const targetId = 'sp-tab-' + btn.dataset.tab;
      tabBtns.forEach(b => {
        const active = b === btn;
        b.classList.toggle('sp-tabs__btn--active', active);
        b.setAttribute('aria-selected', String(active));
        b.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(panel => {
        const active = panel.id === targetId;
        panel.classList.toggle('sp-tabs__panel--active', active);
        active ? panel.removeAttribute('hidden') : panel.setAttribute('hidden', '');
      });
    }

    tabBtns.forEach(btn => {
      btn.addEventListener('click', function () { activateTab(this); });
    });

    const tabNav = $('.sp-tabs__nav');
    if (tabNav) {
      tabNav.addEventListener('keydown', function (e) {
        const current = document.activeElement.closest('.sp-tabs__btn');
        if (!current) return;
        const idx = tabBtns.indexOf(current);
        let next = -1;
        if (e.key === 'ArrowRight') next = (idx + 1) % tabBtns.length;
        else if (e.key === 'ArrowLeft') next = (idx - 1 + tabBtns.length) % tabBtns.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabBtns.length - 1;
        if (next >= 0) {
          e.preventDefault();
          tabBtns[next].focus();
          activateTab(tabBtns[next]);
        }
      });
    }
  }

  /* ═══════════════════════════════════════
     RELATED CAROUSEL
     ═══════════════════════════════════════ */
  function initRelated() {
    const track   = $('#sp-related-track');
    const prevBtn = $('[data-related-prev]');
    const nextBtn = $('[data-related-next]');
    if (!track) return;

    function getScrollAmount() {
      const card = track.querySelector('.sp-related__card');
      if (!card) return 300;
      const gap = parseFloat(window.getComputedStyle(track).gap) || 24;
      return (card.offsetWidth + gap) * 4;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      const maxScroll = track.scrollWidth - track.clientWidth - 4;
      prevBtn.classList.toggle('sp-related__arrow--disabled', track.scrollLeft <= 4);
      nextBtn.classList.toggle('sp-related__arrow--disabled', track.scrollLeft >= maxScroll);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    setTimeout(updateArrows, 150);
  }

    /* ═══════════════════════════════════════
     REVIEWS — ANIMATE BARS ON SCROLL
     ═══════════════════════════════════════ */
  function initReviews() {
    const bars        = $$('.sp-reviews__bar-fill');
    const reviewsSection = $('#sp-reviews');
    const writeBtn    = $('[data-write-review]');

    if (!bars.length) return;

    /* Animate bars when section scrolls into view */
    function animateBars() {
      bars.forEach(bar => {
        const target = bar.dataset.width || '0';
        bar.style.width = target + '%';
      });
    }

    if ('IntersectionObserver' in window && reviewsSection) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animateBars();
            observer.disconnect();
          }
        });
      }, { threshold: 0.2 });
      observer.observe(reviewsSection);
    } else {
      animateBars();
    }

    /* Write a review button */
    if (writeBtn) {
      writeBtn.addEventListener('click', function() {
        /* Judge.me integration:
           window.judgeme && window.judgeme.util.openReviewForm();
        */
        const form = document.querySelector(
          '.jdgm-write-rev-btn, .okeReviews-review-form, #sp-review-form'
        );
        if (form) {
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          console.log('Connect a reviews app to enable review submission.');
        }
      });
    }
  }

  /* ═══════════════════════════════════════
     INIT
     ═══════════════════════════════════════ */
  function init() {
    buildImageData();
    initGallery();
    initLightbox();
    initWishlist();
    initQuantity();
    initTabs();
    initRelated();
    initReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();